import { getController } from '@/controllers/request';
import { MODULE } from '@/utils/constants';

export default {
  namespaced: true,
  state: {
    fields: {},
    title: {},
    metadata: [],
    detailView: {},
    loading: false
  },
  mutations: {
    setParam(state, { name, val, param }) {
      if (param) {
        state[name][param] = val;
      } else {
        state[name] = val;
      }
    },
    setStage(state, value) {
      state.metadata.hrpac_coordination_stages.value = value;
    },
    setFields(state, data) {
      state.fields = { ...data };
    },
    setMetadata(state, metaData) {
      state.metadata = metaData;
    },
    setTitle(state, title) {
      state.title = title;
    },
    setLoading(state, val) {
      state.loading = val;
    }
  },
  actions: {
    async getMetadataView({ commit }, record = '') {
      try {
        commit('setLoading', true);
        const response = await getController({
          params: {
            module: MODULE.HRPAC_COORDINATION_PLANS,
            action: 'getCoordinationPlanDetailView',
            record
          }
        });
        commit('setFields', response.data.bean);
        commit('setTitle', response.data.metadata.title);
        commit('setMetadata', response.data.metadata.panels[0].rows[0]);
        commit(
          'edit/setExitAlert',
          response.data?.exit_alert ? response.data.exit_alert : false,
          { root: true }
        );
        commit('setLoading', false);
      } catch (e) {
        console.error(e);
      }
    }
  }
};
